type NormalizedEntities<T> = { [key: string]: T };

/**
 * Maps array to an object by an identifier - 'id' by default.
 * @param data array of items
 * @param idAttribute id attribute - 'id' by default
 * @return {NormalizedEntities}
 */
export const normalize = <T>(
    data: T[],
    idAttribute = 'id',
): { allIds: string[]; byId: NormalizedEntities<T> } => {
    const byId = {} as NormalizedEntities<T>;

    data.forEach((currentEntity) => {
        // @ts-expect-error no-implicit-any
        byId[currentEntity[idAttribute]] = currentEntity;
    });

    return {
        allIds: data.map((entity) => entity[idAttribute as keyof T]) as string[],
        byId,
    };
};

/**
 * Picks ids from the object and returns them as array
 * @param allIds ids to pick
 * @param byId object where keys are ids
 * @return array of object values
 */
export const denormalize = <T>(allIds: string[] = [], byId: NormalizedEntities<T> = {}): T[] =>
    allIds.map((id) => byId[id]);
